/* eslint-disable */

export const cancelOrderConstants = {
    FETCH_CANCEL_ORDER_REQUEST: 'FETCH_CANCEL_ORDER_REQUEST',
    FETCH_CANCEL_ORDER_SUCCESS: 'FETCH_CANCEL_ORDER_SUCCESS',
    FETCH_CANCEL_ORDER_FAILURE: 'FETCH_CANCEL_ORDER_FAILURE',
};
